(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-navigation-v2"]) return;
  try {
    
  // toggle mobile menu
  const hamburger = document.getElementById('hamburger-icon');
  hamburger.addEventListener('click', () => {
    const hamburgerExpandedOld = hamburger.getAttribute('aria-expanded');
    const hamburgerExpandedNew = hamburgerExpandedOld != 'true' ? 'true' : 'false';
    hamburger.setAttribute('aria-expanded', hamburgerExpandedNew);
    if (hamburgerExpandedNew === 'false') {
      const expandedMenus = document.querySelectorAll('#global-nav [aria-expanded="true"]');
      expandedMenus.forEach((menu) => menu.setAttribute('aria-expanded', 'false'));
    }
  });

  // toggle submenus
  const navButtons = document.querySelectorAll('.nav-button');
  navButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const siblings = document.querySelectorAll(`.nav-button[data-tier="${button.dataset.tier}"]`);
      const newExpandedState = button.getAttribute('aria-expanded') !== 'true' ? 'true' : 'false';
      siblings.forEach((sibling) => sibling.setAttribute('aria-expanded', 'false'));
      button.setAttribute('aria-expanded', newExpandedState);
    });

    const backButton = button.nextElementSibling?.querySelector('.nav-back-button');
    if (backButton) {
      backButton.addEventListener('click', () => {
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      });
    }
  });

  // menu minify on scroll
  const globalNav = document.getElementById('global-nav-container');
  window.addEventListener('scroll', () => {
    if (window.innerWidth < 1024) return;
    const currentScrollY = window.scrollY;
    if (currentScrollY < 80) {
      globalNav.classList.remove('minified');
    } else if (currentScrollY > 155) {
      globalNav.classList.add('minified');
      navButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-department"]) return;
  try {
    
    // CAROUSELS ------------------------------------------------------------------------ /

    const carouselNavButtons = document.querySelectorAll('.carousel-nav');
    if (carouselNavButtons.length > 0) {
      carouselNavButtons.forEach(button => {
        const carouselContent = button.parentElement.querySelector('.carousel-content');
        button.addEventListener('click', function() {
          if (button.classList.contains('right')) {
            carouselContent.scrollBy({ left: carouselContent.offsetWidth * 0.25, behavior: 'smooth' });
          }
          if (button.classList.contains('left')) {
            carouselContent.scrollBy({ left: carouselContent.offsetWidth * -0.25, behavior: 'smooth' });
          }
        });
      });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbo-products"]) return;
  try {
    
  $("#load-trip-imgs").on("click tap", function(){
    $(".trip-img").removeClass("hidden");
    $(this).hide();
  });

  } catch(e) { console.error(e); }
})();
})();
